export const MEDICATION_FORM_QUESTIONS = {
  PHYSICIAN_CONTACTED: {
    label: 'Physician contacted regarding medication discrepancies:',
    options: [
      { value: 'YES', label: 'Yes' },
      { value: 'NO', label: 'No' },
      { value: 'NA', label: 'N/A (No Discrepancies)' },
    ],
  },
  ACTION_TAKEN: {
    label: 'Action taken:',
    options: [
      { value: 'YES', label: 'Yes' },
      { value: 'NO', label: 'No' },
    ],
  },
  INTERACTIONS_NOTIFIED: {
    label: 'Physician notified of severe medication interactions?',
    options: [
      { value: 'YES', label: 'Yes' },
      { value: 'NO', label: 'No' },
      { value: 'NA', label: 'N/A (No Interactions)' },
    ],
  },
} as const;

export const MEDICATION_REVIEW_DISCLAIMER =
  'All medications the patient is currently using have been reviewed for potential adverse effects and drug interactions, including ineffective drug therapy, significant side effects, significant drug interactions, duplicate drug therapy, and noncompliance with drug therapy.';

export const DIGITAL_SIGNATURE_CONFIRMATION =
  'I confirm that I am digitally signing this medication record';

export type YesNoNaValue = 'YES' | 'NO' | 'NA';
export type YesNoValue = 'YES' | 'NO';
